<template>
    <div class="admin-nav">
        <el-menu
            mode="vertical"
            background-color="#324157"
            text-color="#fff"
            :default-active="defActiveKey"
            :default-openeds="authTreeMenuKeys"
            class="el-menu-vertical-nav"
        >
            <el-submenu
                v-for="(menu1, index1) in authTreeMenu"
                v-if="menu1.status && menu1.child && menu1.child.length"
                :index="menu1.action"
                :key="menu1.id"
            >
                <template slot="title"
                    ><i :class="mapIconClass(menu1.action)"></i
                    ><span slot="title">{{ menu1.name }}</span></template
                >
                <el-menu-item
                    v-for="(menu2, index2) in menu1.child"
                    v-if="menu2.status && menu1.child && menu1.child.length"
                    :index="`/${menu1.action}/${menu2.action}`"
                    :key="index2"
                    @click="menuRouteHandler(menu1, menu2)"
                    >{{ menu2.name }}
                </el-menu-item>
            </el-submenu>
            <!-- <el-submenu index="other">
            <template slot="title"><i class="el-icon-menu"></i><span slot="title">其他</span></template>
            <el-menu-item index="1-1" @click="otherMenuRouteHandler('/upload')">图片上传</el-menu-item>
        </el-submenu> -->
        </el-menu>
    </div>
</template>
<script>
import $ from "jquery";

export default {
    data() {
        return {
        };
    },
    methods: {
        menuRouteHandler(m1, m2) {
            let menuPath = `/${m1.action}/${m2.action}`;
            this.$router.push({
                path: menuPath
            });
            this.$store.commit("UPDATE_CUR_MENU", {
                action: m2.action,
                menuPath: menuPath
            });
        },
        mapIconClass(link) {
            let className = "";
            switch (link) {
                case "base_comp":
                    className = "el-icon-my-icon-comp";
                    break;
                case "project":
                case "acttemp":
                    className = "el-icon-my-xiangmu";
                    break;
                case "auth":
                    className = "el-icon-my-quanxian";
                    break;
                case "link":
                    className = "el-icon-my-lianjie";
                    break;
                default:
                    className = "el-icon-menu";
                    break;
            }
            return className;
        },
        otherMenuRouteHandler(path) {
            this.$router.push({
                path: path
            });
        }
    },
    watch: {},
    computed: {
        authTreeMenu() {
            let authTree = this.$store.state.userInfo.auth_points;
            let menus = [];
            if (authTree[0] && authTree[0].child.length) {
                menus = authTree[0].child;
            }
            return menus;
        },
        authTreeMenuKeys() {
            let tmpArr = [];
            tmpArr = _.map(this.authTreeMenu, v => v.action);
            return tmpArr;
        },
        defActiveKey() {
            return this.$store.state.curMenuPath;
        }
    },
    mounted() {}
};
</script>
<style lang="less">
@import (reference) "../../styles/public.less";
.admin-nav {
    .nav();
    .el-icon-menu {
        width: 18px;
    }
}
.el-menu-vertical-nav {
    position: relative;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
}
.nav-link {
    color: #fff;
    display: block;
    outline: none;
    text-decoration: none;
}
.router-link-active {
    color: #20a0ff;
}
.el-menu-item {
    text-indent: 2em;
}
.collapse-btn {
    height: 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    &:hover {
        background-color: #48576a;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/containWraper/nav.vue